export const RESERVED_SLUGS = [
  "",
  "home", "about", "contact", "portfolio", "sales", "bio", "modern", "payment",
  "admin", "admin-preview", "preview",
];

export const isReservedSlug = (slug) => {
  const s = String(slug || "").trim().toLowerCase();
  if (!s) return true;
  if (RESERVED_SLUGS.includes(s)) return true;
  if (s.startsWith("admin")) return true;
  return false;
};

export const slugify = (text) => {
  return String(text || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9- ]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
};

export const getPageBySlug = (pages, slug) => {
  return (pages || []).find((p) => p.slug === slug) || null;
};

export const getPageById = (pages, id) => {
  return (pages || []).find((p) => p.id === id) || null;
};
